import _ from "lodash";
import { memoize } from "proxy-memoize";
import { IFeatureFlagTypes } from "./model";

export const getSiteFeatureFlags = memoize((state: IStoreState) => state.featureFlags?.[state.currentLocationNodeId]);

export const getOrgFeatureFlags = memoize((state: IStoreState) => state.featureFlags?.[state.currentOrganizationNodeId]);

export const isFeatureFlagsLoaded = (state: IStoreState): boolean => !_.isEmpty(state.featureFlags);

export const hasRequiredFeatureFlags = (state: IStoreState, neededFeatureFlags: IFeatureFlagTypes[]): boolean => {
    const orgFeatureFlags = getOrgFeatureFlags(state);
    const siteFeatureFlags = getSiteFeatureFlags(state);

    return _.some(neededFeatureFlags, (f) => orgFeatureFlags?.[f] || siteFeatureFlags?.[f]);
};
